import React from "react";
import MapView from "@/components/maps/MapView";
import { useAuth } from "@/context/AuthContext";

export default function FieldMapPage() {
  const { user } = useAuth();
  
  return (
    <div className="h-[calc(100vh-64px)] -m-4 md:-m-6" data-testid="field-map-page">
      <MapView mode={user?.role === "admin" ? "admin" : "field"} />
    </div>
  );
}
